import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=637df524&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637df524')) {
      api.createRecord('637df524', component.options)
    } else {
      api.reload('637df524', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=637df524&", function () {
      api.rerender('637df524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BJhLeiOazKgm/JS/pricehelp.vue"
export default component.exports